<template>
    <div class="desktop-register">
        <div class="form-wrap">
            <form>
                <Input
                    v-model="name.value"
                    :error-message="name.error"
                    label="Имя *"
                    type="text"
                    @input="name.error = null"
                    required/>
                <Input
                    v-model="surname.value"
                    :error-message="surname.error"
                    label="Фамилия *"
                    type="text"
                    @input="surname.error = null"
                    required/>
                <Input 
                    v-model="email.value"
                    :error-message="email.error"
                    @input="email.error = null"
                    label="Email *"
                    ref="email"
                    type="email" 
                    required/>
                <Input 
                    v-model="password.value"
                    :error-message="password.error"
                    @input="password.error = null"
                    label="Пароль *"
                    type="password"
                    ref="password"
                    required/>
                <Input
                    v-model="repeat.value"
                    :error-message="repeat.error"
                    @input="repeat.error = null"
                    label="Подтверждение пароля *"
                    type="password"
                    ref="repeat"
                    required/>

                <div class="agree">
                    <p-check 
                        class="p-default p-curve" 
                        color="info" 
                        v-model="agree"
                        ref="agree"
                    ></p-check>
                    <label>
                        Я принимаю условия <a>Пользовательского соглашения</a> и даю своё согласие на передачу персональной информации третьим лицам
                        на условиях, определенных <a>Политикой конфиденциальности</a>.
                    </label>
                </div>
                <div class="controls-row">
                    <Btn danger @click="sendForm">Продолжить</Btn>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {mapActions} from 'vuex';
import PrettyCheck from 'pretty-checkbox-vue/check';

Vue.component('p-check', PrettyCheck);

const actions = ['validateEmail', 'register'];

export default {
    name: "RegisterForm",
    data: () => ({
        name: {value: '', error: ''},
        surname: {value: '', error: ''},
        email: {value: '', error: ''},
        password: {value: '', error: ''},
        repeat: {value: '', error: ''},
        agree: false,
    }),
    methods: {
        ...mapActions(actions),
        async sendForm(){
            let data = {
                name: this.name.value,
                surname: this.surname.value,
                email: this.email.value,
                password: this.password.value,
                repeat: this.repeat.value,
                agree: this.agree,
            };
            if(await this.validateForm(data)){
                console.log('send form');
                let submit = {
                    email: data.email,
                    password: data.password,
                    redirect_uri: "",
                    first_name: data.name,
                    second_name: data.surname,
                };
                this.register(submit);
            }
        },
        async validateForm(data) {
            let errors = 0;
            //name
            if(data.name.trim() == ""){
                this.name.error = 'Поле обязательно для заполнения'; errors++;
            } else {
                if(data.name.indexOf(' ') !== -1){
                    this.name.error = 'Имя не может сожержать пробел'; errors++;
                }
                if(data.name.length > 50){
                    this.name.error = 'Максимум 50 символов'; errors++;
                }
            }

            //surname
            if(data.surname.trim() == ""){
                this.surname.error = 'Поле обязательно для заполнения'; errors++;
            } else {
                if(data.surname.indexOf(' ') !== -1){
                    this.surname.error = 'Имя не может сожержать пробел'; errors++;
                }
                if(data.surname.length > 50){
                    this.surname.error = 'Максимум 50 символов'; errors++;
                }
            }

            //email
            if(data.email.trim() == ""){
                this.email.error = 'Поле обязательно для заполнения'; errors++;
            } else {
                if(!await this.validateEmail(data.email) && data.email.indexOf(' ') === -1){
                    this.email.error = 'Введите корректный адрес эл. почты'; errors++;
                }
            }

            //pass
            if(data.password.length < 8){
                this.password.error = 'Пароль должен содержать минимум 8 символов'; errors++;
            }

            //repeat
            if(data.repeat != data.password){
                this.repeat.error = 'Пароли не совпадают'; errors++;
            }

            return errors == 0;

        },
    },
};
</script>

<style lang="scss">
    @import '../../../node_modules/pretty-checkbox/src/pretty-checkbox';
</style>

<style lang="scss" scoped>


    .form-wrap{
        padding-top: 8px;

        .agree{
            margin-bottom: 60px;
            label{
                text-align: justify;
                font-family: "Futura PT", sans-serif;
                font-size: 14px;
                line-height: 18px;
                color: #2A2626;

                @media screen and (max-width: 800px) {
                    
                    font-family: "Montserrat";
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 17px;
                    color: #98A0A9;

                    a {
                        font-family: "Montserrat";
                        font-style: normal;
                        font-weight: normal;
                        font-size: 14px;
                        line-height: 17px;
                        color: #3874E0;
                    }
                }
            }
            a{
                font-size: 13px;
                cursor: pointer;
            }
        }

        .controls-row {
            display: flex;
            justify-content: space-around;
            padding-bottom: 8px;
            
        }

        .error{
            border-color: #ff0000;
        }
    }

    

</style>